module.exports = {"message":{"text":"好好学习，天天向上"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/langs/zh/zh.json
// module id = 64Ft
// module chunks = 4